import { inject, Injectable } from '@angular/core';
import { ADPResourceService } from 'digital-core';
import { GoogleAnalyticsService } from './google-tag-manager.service';
import { MiawChatService } from './miaw-chat.service';
import { MiawChatConfig, MiawCustomerInfo } from 'src/app/model/salesforce-chat/miaw-chat.dto';

/**
 * Service to initialize MIAW Chat in the app component
 */
@Injectable({
  providedIn: 'root',
})
export class MiawChatInitializer {
  private miawChatService = inject(MiawChatService);
  private googleAnalyticsService = inject(GoogleAnalyticsService);
  private resourceService = inject(ADPResourceService);

  /**
   * Initializes MIAW Chat with configuration
   */
  async initialize(customerInfo?: MiawCustomerInfo, language?: string): Promise<void> {
    // Get configuration from portal settings or window.config
    const config = this.buildMiawConfig(language);
    if (!config.Show) {
      return;
    }

    if (!this.miawChatService.isInitialized) {
      // Load the service with configuration
      this.miawChatService.load(config, this.googleAnalyticsService);
    }

    if (!this.miawChatService.isInitialized) {
      // Initialize the chat widget
      await this.miawChatService.initialize();
    }

    // Set customer info if provided
    if (customerInfo) {
      this.miawChatService.setCustomerDetail(customerInfo);
    }
  }

  private buildMiawConfig(language?: string): MiawChatConfig {
    // Option 1: Get from portal settings
    const get = (k: string) => this.resourceService.getPortalSetting(k)?.Value ?? '';

    // Option 2: Hardcode for testing (use Option 1 for production)
    return {
      organizationId: get('Global_MiawChat_OrganizationId'),
      deploymentName: get('Global_MiawChat_DeploymentName'),
      siteUrl: get('Global_MiawChat_SiteUrl'),
      scrt2URL: get('Global_MiawChat_Scrt2URL'),
      language: get('Global_MiawChat_Language') || language || 'en_US',
      Show: get('Global_MiawChat_Show') === 'true', 
    };
  }
}
